import findResult, { findMatch } from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import {
  activeReport,
  activeReports,
  dictionaryReportsDownloadState,
  dictionaryReportsState,
  reportDownloadState,
  findDictionaryReport,
} from './state';
import actions from '../constants';

const fetchDictionaryReports = withDraft((draft, action) => {
  const item = findDictionaryReport(draft, action);

  if (item) {
    const reportList = item[action.reportType];
    reportList.readStatus = states.PENDING;
    reportList.readErrors = [];
    reportList.items = [];
  } else {
    draft.dictionaryReports[action.category].results.push({
      ...dictionaryReportsState(),
      code: action.code,
    });
    const newItem = findDictionaryReport(draft, action);
    const newReportList = newItem[action.reportType];
    newReportList.readStatus = states.PENDING;
  }
});

const fetchDictionaryReportsSuccess = withDraft((draft, action) => {
  const item = findDictionaryReport(draft, action);

  const reportList = item[action.reportType];
  reportList.readStatus = states.SUCCESS;
  reportList.readErrors = [];
  reportList.items = action.result.items;
});

const fetchDictionaryReportsError = withDraft((draft, action) => {
  const item = findDictionaryReport(draft, action);

  const reportList = item[action.reportType];
  reportList.readStatus = states.ERROR;
  reportList.readErrors = [responseError(action)];
});

const showDictionaryReports = withDraft((draft, action) => {
  draft.dictionaryReportsDialog.open = true;
  draft.dictionaryReportsDialog.category = action.category;
  draft.dictionaryReportsDialog.code = action.code;
  draft.dictionaryReportsDialog.name = action.name;
  draft.dictionaryReportsDialog.reportType = action.reportType;
});

const hideDictionaryReports = withDraft((draft, { category, code, reportType }) => {
  draft.dictionaryReportsDialog = activeReports('dictionary');
  const item = findDictionaryReport(draft, { category, code });

  if (item) {
    item[reportType] = dictionaryReportsState()[reportType];
  }

  const downloadItem = findResult(draft.dictionaryReports, 'downloads', code);
  if (downloadItem) {
    downloadItem[reportType] = dictionaryReportsDownloadState()[reportType];
  }
});

const showDictionaryReport = withDraft((draft, action) => {
  draft.dictionaryReportDialog.open = true;
  draft.dictionaryReportDialog.category = action.category;
  draft.dictionaryReportDialog.code = action.code;
  draft.dictionaryReportDialog.name = action.name;
  draft.dictionaryReportDialog.reportType = action.reportType;
  draft.dictionaryReportDialog.reportId = action.reportId;
});

const hideDictionaryReport = withDraft((draft, {
  category,
  code,
  reportId,
  reportType,
}) => {
  draft.dictionaryReportDialog = activeReport('dictionary');
  const item = findDictionaryReport(draft, { category, code });
  if (item) {
    const downloadList = item[reportType];
    downloadList.items = downloadList.items.filter((r) => r.reportId !== reportId);
  }
});

const dictionaryReportDownload = withDraft((draft, action) => {
  const item = findDictionaryReport(draft, action);

  if (item) {
    const downloadList = item[action.reportType];
    const report = findMatch(downloadList.items, action.report.id, 'reportId');
    if (report) {
      report.readStatus = states.PENDING;
      report.readErrors = [];
    } else {
      downloadList.items.push({
        ...reportDownloadState(),
        reportId: action.report.id,
        readStatus: states.PENDING,
      });
    }
  } else {
    draft.dictionaryReports[action.category].results.push({
      ...dictionaryReportsDownloadState(),
      code: action.code,
    });
    const newItem = findDictionaryReport(draft, action);
    const newDownloadList = newItem[action.reportType];
    newDownloadList.items.push({
      ...reportDownloadState(),
      reportId: action.report.id,
      readStatus: states.PENDING,
    });
  }
});

const dictionaryReportDownloadSuccess = withDraft((draft, action) => {
  const item = findDictionaryReport(draft, action);
  const downloadList = item[action.reportType];
  const report = findMatch(downloadList.items, action.report.id, 'reportId');

  report.data = action.response;
  report.readStatus = states.SUCCESS;
  report.readErrors = [];
});

const dictionaryReportDownloadError = withDraft((draft, action) => {
  const item = findDictionaryReport(draft, action);
  const downloadList = item[action.reportType];
  const report = findMatch(downloadList.items, action.report.id, 'reportId');

  report.readStatus = states.ERROR;
  report.readErrors = [responseError(action)];
});

export default {
  [actions.DICTIONARY_REPORT_DOWNLOAD]: dictionaryReportDownload,
  [actions.DICTIONARY_REPORT_DOWNLOAD_ERROR]: dictionaryReportDownloadError,
  [actions.DICTIONARY_REPORT_DOWNLOAD_SUCCESS]: dictionaryReportDownloadSuccess,
  [actions.FETCH_DICTIONARY_REPORTS]: fetchDictionaryReports,
  [actions.FETCH_DICTIONARY_REPORTS_ERROR]: fetchDictionaryReportsError,
  [actions.FETCH_DICTIONARY_REPORTS_SUCCESS]: fetchDictionaryReportsSuccess,
  [actions.HIDE_DICTIONARY_REPORT]: hideDictionaryReport,
  [actions.HIDE_DICTIONARY_REPORTS]: hideDictionaryReports,
  [actions.SHOW_DICTIONARY_REPORT]: showDictionaryReport,
  [actions.SHOW_DICTIONARY_REPORTS]: showDictionaryReports,
};
